import React, { useState } from 'react';
import styles from './ContactForm.module.scss';
import PropTypes from 'prop-types'

const ContactForm = ({ titleContent }) => {
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);
  const [formData, setFormData] = useState({
    Name: '',
    PhoneNumber: ''
  });

  const PHONE_PREFIX = '+(48)';

  const formatPhoneNumber = (value) => {
    // Удаляем все нецифры кроме префикса
    const digits = value.replace(/\D/g, '').slice(0, 9);
    // Форматируем через дефисы
    const formatted = digits.replace(/(\d{3})(\d{3})(\d{0,3})/, (m, p1, p2, p3) => {
      return [p1, p2, p3].filter(Boolean).join('-');
    });
    return formatted;
  };

  const handlePhoneChange = (e) => {
    let input = e.target.value;

    // Если поле пустое, не добавляем префикс
    if (input === '') {
      setFormData({
        ...formData,
        PhoneNumber: ''
      });
      setMessage('');
      return;
    }

    // Если пользователь начинает вводить, добавляем префикс
    if (!input.startsWith(PHONE_PREFIX)) {
      input = PHONE_PREFIX + input.replace(/\D/g, '').slice(0, 9);
    }

    // Получаем только цифры после префикса
    const digits = input.slice(PHONE_PREFIX.length).replace(/\D/g, '').slice(0, 9);
    const formatted = formatPhoneNumber(digits);

    setFormData({
      ...formData,
      PhoneNumber: PHONE_PREFIX + formatted
    });
    setMessage('');
  };

  const handlePhoneFocus = (e) => {
    if (formData.PhoneNumber === '') {
      setFormData({
        ...formData,
        PhoneNumber: PHONE_PREFIX
      });
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setMessage('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');

    try {
      const response = await fetch('/api/notify', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setIsSuccess(true);
        setMessage('Заявка успешно отправлена.');
      } else {
        setIsSuccess(false);
        const responseData = await response.json();
        const responseCode = responseData.responseCode;

        switch (responseCode) {
          case 'PhoneNumberWrongFormat':
            setMessage('Неверный формат номера.');
            break;
          case 'RequestAlreadyCreated':
            setMessage('Заявка уже существует.');
            break;
          case 'NameWrongFormat':
            setMessage('Имя не может быть пустым или длиннее 50 символов.');
            break;
          case 'CommentWrongFormat':
            setMessage('Комментарии не может быть длиннее 600 символов.');
            break;
          default:
            setMessage('Что то пошло не так, попробуйте позже');
            break;
        }
      }
    } catch (error) {
      setMessage('Что то пошло не так, попробуйте позже');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.contactFrom}>
      <div className={styles.textBlock}>
        <span className={styles.title}>
          {titleContent}
        </span>
        <span className={styles.content}>
          Закажите обратный звонок - мы вам перезвоним
        </span>
      </div>
      <form onSubmit={handleSubmit}>
        <div className={styles.inputsBlock}>
          <input
            required
            onChange={handleChange}
            value={formData.Name}
            name="Name"
            type='text'
            placeholder='Имя'
          />
          <input
            required
            onChange={handlePhoneChange}
            onFocus={handlePhoneFocus}
            value={formData.PhoneNumber}
            name="PhoneNumber"
            type='tel'
            placeholder='(+48)XXX-XXX-XXX'
            maxLength={PHONE_PREFIX.length + 11} // префикс + 9 цифр + 2 дефиса
            pattern="\+\(48\)\d{3}-\d{3}-\d{3}"
          />
        </div>
        <button><p>оставить заявку</p></button>
      </form>
      {message && (
        <p style={{ color: isSuccess ? 'green' : 'red' }}>
          {message}
        </p>
      )}
    </div>
  )
}

ContactForm.propTypes = {
  titleContent: PropTypes.string
}

export default ContactForm